import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { DefaultButton as FluentUIDefaultButton } from '@fluentui/react';

import { BaseButton } from '../BaseButton';
import { IButtonImplProps } from '../BaseButton.types';

export const DefaultButton = (props: IButtonImplProps) => <BaseButton componentAs={FluentUIDefaultButton} {...props} />;
